import logo from "./logo.svg";
import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Switch,
} from "react-router-dom";
import "./pages/NavBar/style1.css"
import Home from "./pages/NavBar/header";
import Sidebar from "./pages/NavBar/NavBar";
import Auditsummary from "./pages/NavBar/Auditsummary";
import Schemaanalysis from "./pages/NavBar/Schemaanalysis";
import Schemadetail from "./pages/NavBar/schema/Schemadetail";
import ContentauditDetails from "./pages/NavBar/Contentaudit/ContentauditDetail";
import Codeauditlist from "./pages/NavBar/codeaudit/Codeauditlist";
import CodeauditDetail from "./pages/NavBar/codeaudit/CodeauditDetail";
import Plagiarisamlist from "./pages/NavBar/plagiarisam/Plagiarisamlist";
import Plagiarisamdetail from "./pages/NavBar/plagiarisam/Plagiarisamdetail";
import Plagiarisamscandetail from "./pages/NavBar/plagiarisam/Plagiarisamscandetail";
import Linkchecklists from "./pages/NavBar/linkchecker/Linkchecklists";
import Siteanalysisignore from "./pages/NavBar/ignoremetrics/Siteanalysis";
import Siteanalysis from "./pages/NavBar/siteaudit/Siteanalysis";
import Sitepageanalysis from "./pages/NavBar/siteaudit/Sitepageanalysis";
import Sitecompetoranalysis from "./pages/NavBar/siteaudit/Sitecompetoranalysis";
import Competitoranalysisignore from "./pages/NavBar/ignoremetrics/Sitecompetoranalysis"
import Siteonanalysis from "./pages/NavBar/siteaudit/Siteonanalysis";
import Onpageanalysisignore from "./pages/NavBar/ignoremetrics/Siteonanalysis"
import Pagehealthlists from "./pages/NavBar/siteaudit/Pagehealthlists";
import Pagehealthdetailignore from "./pages/NavBar/ignoremetrics/Pagehealthdetail"
import Pagehealthdetail from "./pages/NavBar/siteaudit/Pagehealthdetail";
import Imagedetails from "./pages/NavBar/siteaudit/ImageDetails";
import Missingimagedetails from "./pages/NavBar/siteaudit/Missingimagedetails";
import Performancelist from "./pages/NavBar/Performance/Performancelist";
import Performancedetail from "./pages/NavBar/Performance/Detail";
import Accessbilitydetail from "./pages/NavBar/AccessbilityReport/Detail";
import Accessbilityfile from "./pages/NavBar/Accessibilityfile/Generate";
import Accessbilityfiledetail from "./pages/NavBar/Accessibilityfile/Detail";
import Regressiontest from "./pages/NavBar/regressiontest/Regressionlist";
import Spellcheckerlist from "./pages/NavBar/spellchecker/Spellcheckerlist";
import SpellcheckerDetail from "./pages/NavBar/spellchecker/SpellcheckerDetail";
import AccessibilityList from "./pages/NavBar/AccessbilityScore/List";
import AccessbilityScoreDetails from "./pages/NavBar/AccessbilityScore/Detail";
import AccessibilityaxeList from "./pages/NavBar/AccessbilityAxe/List";
import AccessbilityaxeDetails from "./pages/NavBar/AccessbilityAxe/Detail";
import AccessbilityaxescanDetails from "./pages/NavBar/AccessbilityAxe/Detailaxe"
import InternallinkSource from "./pages/NavBar/linkchecker/InternallinkSource";
import InternallinkOutbound from "./pages/NavBar/linkchecker/InternalLinkOutbound";
import ExternalLinkLists from "./pages/NavBar/linkchecker/ExternalLink";
import PerformnceLevarageList from "./pages/NavBar/Performance/PerformanceLevarage";
import PerformnceRenderBlockingList from "./pages/NavBar/Performance/PerformanceRenderBlocking";
import GoogleLoginCom from "./pages/NavBar/Login";
import AppleLoginCom from "./pages/NavBar/AppleLogin";
import KeywordsList from "./pages/NavBar/KeyWords/KeyWordsList";
import AddcampaignList from "./pages/NavBar/KeyWords/Addcampaigndata";
import Addbrands from "./pages/NavBar/KeyWords/Addbrands";
import Searchkeyvolumelist from "./pages/NavBar/searchkeyvolume/Searchkeyvolumelist";
import Standardreport from "./pages/NavBar/standardreport/Standardreport";
import Competitorlist from "./pages/NavBar/Competitor_ranking/Competitorlist";
import MissedOpportunity from "./pages/NavBar/MissedOpportunity/Missedopportunity";
import Rankingsummary from "./pages/NavBar/Rankingsummary/Rankingsummarylists";
import LoginPage from "./pages/login/Newlogin";
import Newlogin from "./pages/login/Newlogin";
import NewIndex from "./pages/login/Index";
import Registration from "./pages/login/Registration";

import ResetPassword from "./pages/login/passwordreset";
import ResetSuccess from "./pages/login/ResetSuccess";
import ResetPasswordConformation from "./pages/login/conformSection";
import ApprovePassword from "./pages/login/ApprovePassword";
import VisibilityScoreDetail from "./pages/NavBar/Rankingsummary/VisibilityScoreDetails";
import LinkedDomainList from "./pages/NavBar/Backllinks/LinkedDomainList";
import RankingListDetail from "./pages/NavBar/Rankingsummary/RankingListDetail";
import BackLinksIndex from "./pages/NavBar/Backllinks/BacklinkIndex";
import Linklist from "./pages/NavBar/Backllinks/New_link/Linklists";
import MainDashboard from "./pages/NavBar/Dashboard/Dashboard";
import LoginMiddleWare from "./pages/login/LoginMiddleware";
import ChangePassword from "./pages/login/ChangePassword";
import Myaccount from "./pages/login/Myaccount";
import ScrollToTop from "./ScrolltoTop";
import CheckMail from "./pages/Registration/CheckMail";
import Userdata from "./pages/NavBar/LoginDetail/Userdata";
import Domaindata from "./pages/NavBar/LoginDetail/Domaindata";
import Domainownership from "./pages/NavBar/LoginDetail/Domainownership";
import Googleanalytics from "./pages/NavBar/LoginDetail/Googleanalytics";
import DomainList from "./pages/NavBar/UserDomainList/UserDomainList";
import UserRole from "./pages/NavBar/UserRole/UserRole";
import AddForm from "./pages/NavBar/UserRole/AddForm"
import EditForm from "./pages/NavBar/UserRole/EditForm"
import AddDomaindata from "./pages/NavBar/UserDomainList/Domaindata";
import EditDomaindata from "./pages/NavBar/UserDomainList/EditDomaindata";
import Plans from "./pages/NavBar/Subscriptions/Plans";
import Plandetails from "./pages/NavBar/Subscriptions/DetailPlan";
import RazorpayPlan from "./pages/NavBar/Subscriptions/RazorpayPlan"
import GoogleConsole from "./pages/NavBar/GoogleConsole/Console";
import OrganicsearchClicks from "./pages/NavBar/Googleanalytics/OrganicsearchClicks";
import TopPerformingPages from "./pages/NavBar/GoogleConsole/TopPerformingPages";
import SearchQueries from "./pages/NavBar/GoogleConsole/SearchQueries";
import Errorpage from "./pages/NavBar/Errorpage/Errorpage";
import Errorpages from "./pages/NavBar/Errorpage/Errorpages";
import ConfirmError from "./pages/NavBar/Errorpage/ConfirmError";
import SiteMapGenerator from "./pages/NavBar/SiteMap/Generate";
import TopactionItems from "./pages/NavBar/topactionitems/TopactionItems";
import Reporthistory from "./pages/NavBar/reporthistory/Reporthistory"
import BrandMentions from "./pages/NavBar/KeyWords/BrandMentions";
import SiteAuditConfig from "./pages/NavBar/Settings/SiteAuditConfig";
import Topactionsetting from "./pages/NavBar/Settings/Topactionsetting"
import UserDomainsecList from "./pages/NavBar/UserDomainSection/UserDomainsecList";
import DomainAddForm from "./pages/NavBar/UserDomainSection/DomainAddForm"
import EditDomainsecdata from "./pages/NavBar/UserDomainSection/EditDomainsecdata"
import CompetitorSettings from "./pages/NavBar/CompetitorSettings/UserDomainsecList";
import AddCompetitorSettings from "./pages/NavBar/CompetitorSettings/DomainAddForm";
import Editcompetitorsecdata from "./pages/NavBar/CompetitorSettings/EditDomainsecdata";
import PageLevelSetting from "./pages/NavBar/Settings/PageLevelSetting";
import SpellcheckerSettings from "./pages/NavBar/SpellcheckerSettings/UserDomainsecList";
import AddSpellcheckerSettings from "./pages/NavBar/SpellcheckerSettings/DomainAddForm";
import RegionallevelSetting from "./pages/NavBar/Settings/RegionallevelSetting";
import Addkeyword from "./pages/NavBar/KeyWords/KeywordAddForm"
import KeywordEditForm from "./pages/NavBar/KeyWords/KeywordEditForm"
import DoaminGoogleanalytics from "./pages/NavBar/UserDomainList/Googleanalytics"
import DomainownershipData from "./pages/NavBar/UserDomainList/Domainownership"
import Pageindexlist from "./pages/NavBar/Pageindex/Pageindexlists"
import Accessbilityreportlist from "./pages/NavBar/AccessbilityReport/List"
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import axios from "../src/pages/login/AxiosMiddleWare";
import UserExperienceSettings from "./pages/NavBar/Settings/UserExperience";
import AutoDeploymentSettings from "./pages/NavBar/Settings/AutoDeploymentSettings";
import LinkCheckerSettings from "./pages/NavBar/Settings/LinkCheckerSettings";
import ReportSettings from "./pages/NavBar/Settings/ReportSettings";
import Customreport from "./pages/NavBar/Customreport";
import AccessibilitySummary from "./pages/NavBar/AccessibilitySummary/AccessibilitySummary";

import Userlogincontext from './pages/login/Userlogincontext';
import ErrorReport from "./pages/NavBar/Errorreport/ErrorReport"
import Keywordsuggestion from "./pages/NavBar/keywordsuggestion/Keywordsuggestion"
import Keywordsuggestiondetail from "./pages/NavBar/keywordsuggestion/Keywordsuggestiondetail";
import Impadddomain from "./pages/NavBar/LoginDetail/Impadddomain";
import Userpermission from "./Commonalert/Userpermission";
import useVersionChecker from './hooks/useVersionChecker'; // adjust path as needed
import CreateTicketForm from "./pages/NavBar/support-ticket/CreateTicketForm"
import NewSidebar from "./pages/NavBar/NewSidebar"
import ColorContrastChecker from "./pages/NavBar/ColorContrastChecker"
import BusinessMobile from "./pages/NavBar/LoginDetail/businessmobile";
import Ticketdetail from "./pages/NavBar/support-ticket/Ticketdetail";
import SupportclosedTicket from "./pages/NavBar/support-ticket/SupportclosedTicket";
import SupportTicket from "./pages/NavBar/support-ticket/SupportTicket";
import EmailsettingNotification from "./pages/NavBar/Settings/EmailsettingNotification";
import ContainerSecureAudit from "./pages/NavBar/SecurityTools/ContainerSecurity-Audit/container-security-audit";
import GitAudit from "./pages/NavBar/SecurityTools/GitAudit/git-audit";
import SslConfig from "./pages/NavBar/SecurityTools/SSLConfigAudit/ssl-config-audit";
import SourceCodeAudit from "./pages/NavBar/SecurityTools/SourceCodeAudit/sourcecode-audit";
import SecurityAuditSettings from "./pages/NavBar/SecurityTools/SecurityAuditSettings/securityaudit-settings";
import VulnerabilityAudit from "./pages/NavBar/SecurityTools/VulnerabilityAudit/vulnerabilityaudit";
import VulnerabilityDetail from "./pages/NavBar/SecurityTools/VulnerabilityAudit/vulnerabilityDetail";
import VisualValidation from "./pages/NavBar/VisualValidation/visualValidation";

import ContentStructureSummary from "./pages/NavBar/Performance/ContentStructureSummary";
import ContentStructureDetail from "./pages/NavBar/Performance/ContentStructureDetail";
import NetworkHealthSummary from "./pages/NavBar/Performance/NetworkHealthSummary";
import NetworkHealthSummaryDetail from "./pages/NavBar/Performance/NetworkHealthSummaryDetail";

import Pricingpage from "./pages/NavBar/Pricingpage";
import ChatAIButton from "./Components/ChatAI/chatAI";
import InstantReport from "./pages/NavBar/InstantReport/instantReport";
import AccessbilityScorescanDetails from "./pages/NavBar/InstantReport/accessbilityAxeScan";

import AiReadiness from "./pages/NavBar/AiReadiness/AiReadiness";
import AiReadinessDetail from "./pages/NavBar/AiReadiness/AiReadinessDetail";
import AiPerformanceTracking from "./pages/NavBar/AiPerformanceTracking/AiPerformanceTracking";

import AicitationReport from "./pages/NavBar/AiPerformanceTracking/AicitationReport";

import Aiauditsummary from "./pages/NavBar/Contentaudit/Aiauditsummary";
import { Business } from "@mui/icons-material";
import BrandmentioncitationReport from "./pages/NavBar/AiPerformanceTracking/BrandmentioncitationReport";

import Topicresearchdata from "./pages/NavBar/topicresearch/Topicresearchdata";
import Topicresearchdetail from "./pages/NavBar/topicresearch/Topicresearchdetail";
import LinkBuilding from "./pages/NavBar/LinkBuilding/linkBuilding";
import AiContentOptimizer from "./pages/NavBar/AiContentOptimizer/AiContentOptimizer";
import OutreachAssistant from "./pages/NavBar/OutreachAssistant/oureachAssistant";

const App = () => {
  useVersionChecker();
  return (
    <>
      {/* <ChatAIButton /> */}
      <Router>
        <ScrollToTop />
        <Routes>

          <Route
            exact
            path="/login-page"
            element={
              <>
                <Newlogin />
              </>
            }
          />
          <Route
            exact
            path="/business-mobile"
            element={
              <>
                <BusinessMobile />
              </>
            }
          />
          <Route
            exact
            path="/Userdata"
            element={
              <>
                <Userdata />
              </>
            }
          />
          <Route
            exact
            path="/Impadddomain"
            element={
              <>
                <Impadddomain />
              </>
            }
          />
          <Route
            exact
            path="/Domaindata"
            element={
              <>
                <Domaindata />
              </>
            }
          />
          <Route
            exact
            path="/Domainownership"
            element={
              <>
                <Domainownership />
              </>
            }
          />
          <Route
            exact
            path="/Googleanalytics"
            element={
              <>
                <Googleanalytics />
              </>
            }
          />
          <Route
            exact
            path="/"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <MainDashboard />
              </>
            }
          />
          <Route
            exact
            path="/analysis-summary"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Auditsummary />
              </>
            }
          />
          <Route
            exact
            path="/plagiarism-checker"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Plagiarisamlist />
              </>
            }
          />
          <Route
            exact
            path="/plagiarism-detail/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Plagiarisamdetail />
              </>
            }
          />
          <Route
            exact
            path="/plagiarism-scan-detail/:detailid/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Plagiarisamscandetail />
              </>
            }
          />
          <Route
            exact
            path="/schema-analysis"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Schemaanalysis />
              </>
            }
          />
          <Route
            exact
            path="/schema-detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Schemadetail />
              </>
            }
          />
          <Route
            exact
            path="/content-detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <ContentauditDetails />
              </>
            }
          />
          <Route
            exact
            path="/source-code"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Codeauditlist />
              </>
            }
          />
          <Route
            exact
            path="/source-code-detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <CodeauditDetail />
              </>
            }
          />
          <Route
            exact
            path="/internal-link-checker"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Linkchecklists />
              </>
            }
          />

          <Route
            exact
            path="/external-link-checker"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <ExternalLinkLists />
              </>
            }
          />

          <Route
            exact
            path="/internal-link-checker/source/:jobid/:datajobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <InternallinkSource />
              </>
            }
          />

          <Route
            exact
            path="/internal-link-checker/out-bound/:jobid/:datajobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <InternallinkOutbound />
              </>
            }
          />

          <Route
            exact
            path="/site-audit/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Siteanalysis />
              </>
            }
          />
          <Route
            exact
            path="/page-health/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Sitepageanalysis />
              </>
            }
          />
          <Route
            exact
            path="/competitor-analysis/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Sitecompetoranalysis />
              </>
            }
          />
          <Route
            exact
            path="/onpage-crawl-data/:id/:onid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Siteonanalysis />
              </>
            }
          />
          <Route
            exact
            path="/pagehealth-detail/:id/:onpageid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Pagehealthdetail />
              </>
            }
          />
          <Route
            exact
            path="/image-detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Imagedetails />
              </>
            }
          />
          <Route
            exact
            path="/missing-image-detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Missingimagedetails />
              </>
            }
          />
          <Route
            exact
            path="/keywords"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <KeywordsList />

              </>
            }
          />
          <Route
            exact
            path="/add-campaign"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AddcampaignList />
              </>
            }
          />
          <Route
            exact
            path="/edit-campaign/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AddcampaignList />
              </>
            }
          />
          <Route
            exact
            path="/add-brands"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Addbrands />
              </>
            }
          />
          <Route
            exact
            path="/ux-analysis"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Performancelist />
              </>
            }
          />
          <Route
            exact
            path="/ux-analysis-detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Performancedetail />
              </>
            }
          />

          <Route
            exact
            path="/ux-analysis/leverage/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <PerformnceLevarageList />
              </>
            }
          />
          <Route
            exact
            path="/ux-analysis/render-blocking/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <PerformnceRenderBlockingList />
              </>
            }
          />
          <Route
            exact
            path="/regression-test"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Regressiontest />
              </>
            }
          />
          <Route
            exact
            path="/spell-checker"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Spellcheckerlist />
              </>
            }
          />
          <Route
            exact
            path="/spell-checker-detail/:detailid/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SpellcheckerDetail />
              </>
            }
          />
          {/* <Route
            exact
            path="/accessibility-score"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Sidebar />
                <Home />
                <AccessibilityList />
              </>
            }
          /> */}
          {/* <Route
            path="/accessibility-score-detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Sidebar />
                <Home />
                <AccessbilityScoreDetails />
              </>
            }
          /> */}


          <Route
            exact
            path="/accessibility-score"
            // path="/accessibility-axe"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                {/* <ChatAIButton /> */}
                <AccessibilityaxeList />
              </>
            }
          />
          <Route
            path="/accessibility-score-detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AccessbilityaxeDetails />
              </>
            }
          />



          <Route
            path="/accessibility-score-scan-detail/:id/:sid/:saudit/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AccessbilityaxescanDetails />
              </>
            }
          />
          <Route
            path="/accessibility-score-scan-detail/"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AccessbilityScorescanDetails />
              </>
            }
          />



          <Route
            path="/google-login"
            element={
              <>

                <Sidebar />
                <Home />
                <GoogleLoginCom />
              </>
            }
          />

          <Route
            path="/apple-login"
            element={
              <>
                <Sidebar />
                <Home />
                <AppleLoginCom />
              </>
            }
          />
          <Route
            exact
            path="/searchkey-volume"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Searchkeyvolumelist />
              </>
            }
          />
          <Route
            exact
            path="/competitor-ranking"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Competitorlist />
              </>
            }
          />
          <Route
            exact
            path="/missed-opportunity"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <MissedOpportunity />
              </>
            }
          />
          <Route
            exact
            path="/ranking-summary"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Rankingsummary />
              </>
            }
          />
          <Route
            exact
            path="/ranking-summary/:idval"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Rankingsummary />
              </>
            }
          />
          <Route
            exact
            path="/login"
            element={
              <>
                <LoginPage />
              </>
            }
          />
          <Route
            exact
            path="/signup"
            element={
              <>
                <NewIndex />
              </>
            }
          />
          <Route
            exact
            path="/registration"
            element={
              <>
                <Registration />
              </>
            }
          />
          <Route
            exact
            path="/password-reset"
            element={
              <>
                <ResetPassword />
              </>
            }
          />
          <Route
            exact
            path="/reset-success"
            element={
              <>
                <ResetSuccess />
              </>
            }
          />
          <Route
            exact
            path="/reset-password/:uid/:utoken"
            element={
              <>
                <ResetPasswordConformation />
              </>
            }
          />
          <Route
            exact
            path="/updated-password/:uid/:utoken"
            element={
              <>
                <ApprovePassword />
              </>
            }
          />
          <Route
            exact
            path="/confirm-url/:uid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <ConfirmError />
              </>
            }
          />
          <Route
            exact
            path="/ranking-summary/detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <RankingListDetail />
              </>
            }
          />
          <Route
            exact
            path="/visibility-score-detail"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <VisibilityScoreDetail />
              </>
            }
          />
          <Route
            exact
            path="/linked-domain"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <LinkedDomainList />
              </>
            }
          />
          <Route
            exact
            path="/new-lost-link"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Linklist />
              </>
            }
          />
          <Route
            exact
            path="/backLinks"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <BackLinksIndex />
              </>
            }
          />

          <Route
            exact
            path="/change-password"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <ChangePassword />
              </>
            }
          />
          <Route
            exact
            path="/my-account"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <Myaccount />
              </>
            }
          />
          <Route
            exact
            path="/domain-list"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <DomainList />
              </>
            }
          />
          <Route
            exact
            path="/user-list"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <UserRole />
              </>
            }
          />
          <Route
            exact
            path="/add-role"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <AddForm />
              </>
            }
          />

          <Route
            exact
            path="/user-permission"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <Userpermission />
              </>
            }
          />



          <Route
            exact
            path="/edit-role/:id"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <EditForm />
              </>
            }
          />

          <Route
            exact
            path="/add-domain-list"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <AddDomaindata />
              </>
            }
          />
          <Route
            exact
            path="/edit-domain-list/:id"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <EditDomaindata />
              </>
            }
          />
          <Route
            exact
            path="/domain-google_analytics/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <DoaminGoogleanalytics />
              </>
            }
          />
          <Route
            exact
            path="/domain-google_analytics"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <DoaminGoogleanalytics />
              </>
            }
          />
          <Route
            exact
            path="/domain-list/domain-ownership"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <DomainownershipData />
              </>
            }
          />
          <Route
            exact
            path="/domain-list/domain-ownership/:id"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <DomainownershipData />
              </>
            }
          />
          <Route
            exact
            path="/email-verification"
            element={
              <>
                <CheckMail />
              </>
            }
          />
          <Route
            exact
            path="/organic-search-traffic"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <OrganicsearchClicks />
              </>
            }
          />

          <Route
            exact
            path="/google-console/brand-vs-non-brand"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <GoogleConsole />
              </>
            }
          />
          <Route
            exact
            path="/google-console/search-queries"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SearchQueries />
              </>
            }
          />

          <Route
            exact
            path="/google-console/top-performing-pages"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <TopPerformingPages />
              </>
            }
          />

          <Route
            exact
            path="/google-console/search-queries"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SearchQueries />
              </>
            }
          />

          <Route
            exact
            path="/subscription"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Plans />
              </>
            }
          />

          <Route
            exact
            path="/subscription/auth-check"
            element={
              <>
                <LoginMiddleWare />

                <Plans />
              </>
            }
          />

          <Route
            exact
            path="*"
            element={
              <>
                <LoginMiddleWare />

                <Home />
                <Sidebar />
                <Errorpage />
              </>
            }
          />
          <Route
            exact
            path="errorpages"
            element={
              <>
                <LoginMiddleWare />

                <Home />
                <Sidebar />
                <Errorpages />
              </>
            }
          />
          <Route
            exact
            path="login-errorpages"
            element={
              <>
                <Errorpages />
              </>
            }
          />
          <Route
            exact
            path="/sitemap-generator"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SiteMapGenerator />
              </>
            }
          />
          <Route
            exact
            path="/top-action-item"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <TopactionItems />
              </>
            }
          />
          <Route
            exact
            path="/report-history"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Reporthistory />
              </>
            }
          />

          <Route
            exact
            path="/brand-mentions"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <BrandMentions />
              </>
            }
          />

          <Route
            exact
            path="/site-audit-priority"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SiteAuditConfig />

              </>
            }
          />
          <Route
            exact
            path="/top-action-priority"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Topactionsetting />

              </>
            }
          />
          <Route
            exact
            path="/page-level-setting"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <PageLevelSetting />

              </>
            }
          />
          <Route
            exact
            path="/domain-section-list"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <UserDomainsecList />

              </>
            }
          />
          <Route
            exact
            path="/edit-domainsec-list/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <EditDomainsecdata />

              </>
            }
          />
          <Route
            exact
            path="/add-section-list"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <DomainAddForm />

              </>
            }
          />
          <Route
            exact
            path="/competitor-settings"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <CompetitorSettings />

              </>
            }
          />
          <Route
            exact
            path="/add-competitor-list"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AddCompetitorSettings />

              </>
            }
          />
          <Route
            exact
            path="/edit-competitordomain-list/:id"
            element={
              <>
                <LoginMiddleWare />
                <Home />
                <Sidebar />
                <Editcompetitorsecdata />

              </>
            }
          />

          <Route
            exact
            path="/user-experience-setting"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <UserExperienceSettings />

              </>
            }
          />
          <Route
            exact
            path="/auto-deployment-settings"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AutoDeploymentSettings />
              </>
            }
          />
          <Route
            exact
            path="/spell-checker-settings"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SpellcheckerSettings />

              </>
            }
          />
          <Route
            exact
            path="/add-spellchecker-list"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />

                <Home />
                <Sidebar />
                <AddSpellcheckerSettings />

              </>
            }
          />
          <Route
            exact
            path="/regional-level-settings"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <RegionallevelSetting />
              </>
            }
          />
          <Route
            exact
            path="/add-keyword"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Sidebar />
                <Home />
                <Addkeyword />
              </>
            }
          />
          <Route
            exact
            path="/edit-keyword/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Sidebar />
                <Home />
                <KeywordEditForm />
              </>
            }
          />
          <Route
            exact
            path="/page-index-report"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Pageindexlist />
              </>
            }
          />
          <Route
            exact
            path="/accessibility-report"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Accessbilityreportlist />
              </>
            }
          />
          <Route
            exact
            path="/accessibility-report-detail/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Accessbilitydetail />
              </>
            }
          />
          <Route
            exact
            path="/accessibility-file"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Accessbilityfile />
              </>
            }
          />
          <Route
            exact
            path="/fileaccessibility-detail/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Accessbilityfiledetail />
              </>

            }
          />
          <Route
            exact
            path="/custom-report"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Customreport />
              </>
            }
          />
          <Route
            exact
            path="/instant-report"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <InstantReport />
              </>
            }
          />
          <Route
            exact
            path="/accessibility-summary"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AccessibilitySummary />
              </>
            }
          />
          <Route
            exact
            path="/standard-report"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Standardreport />
              </>
            }
          />
          <Route
            exact
            path="/plan-details/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Plandetails />
              </>
            }
          />


          <Route
            exact
            path="/site-audit-ignore-metrics/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Siteanalysisignore />
              </>
            }
          />
          <Route
            exact
            path="/page-health-ignore-metrics/:id/:onpageid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Pagehealthdetailignore />
              </>
            }
          />
          <Route
            exact
            path="/competitor-analysis-ignore-metrics/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Competitoranalysisignore />
              </>
            }
          />
          <Route
            exact
            path="/on-page-crawl-ignore-metrics/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Onpageanalysisignore />
              </>
            }
          />
          <Route
            exact
            path="/error-report"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <ErrorReport />
              </>
            }
          />
          <Route
            exact
            path="/keyword-suggestion"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Keywordsuggestion />
              </>
            }
          />
          <Route
            exact
            path="/keyword-suggestion-detail/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Keywordsuggestiondetail />
              </>
            }
          />
          <Route
            exact
            path="/link-checker-settings"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <LinkCheckerSettings />

              </>
            }
          />
          <Route
            exact
            path="/report-settings"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <ReportSettings />
              </>
            }
          />
          <Route
            exact
            path="/support-form"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <CreateTicketForm />
              </>
            }
          />
          {/* <Route
            exact
            path="/support-ticket-list"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SupportTicket />
              </>
            }
          /> */}
          {/* <Route
            exact
            path="/ticketdetail/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Ticketdetail />
              </>
            }
          /> */}
          <Route
            exact
            path="/color-checker"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <ColorContrastChecker />
              </>
            }
          />
          <Route
            exact
            path="/support-form"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <CreateTicketForm />
              </>
            }
          />
          <Route
            exact
            path="/support-open-ticket-list"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SupportTicket />
              </>
            }
          />
          <Route
            exact
            path="/support-closed-ticket-list"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SupportclosedTicket />
              </>
            }
          />
          <Route
            exact
            path="/ticketdetail/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Ticketdetail />
              </>
            }
          />
          <Route
            exact
            path="/notification-setting"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <EmailsettingNotification />
              </>
            }
          />
          <Route
            exact
            path="/docker-container-audit"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <ContainerSecureAudit />
              </>
            }
          />
          <Route
            exact
            path="/sourcecode-audit"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SourceCodeAudit />
              </>
            }
          />
          <Route
            exact
            path="/git-secret-audit"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <GitAudit />
              </>
            }
          />
          <Route
            exact
            path="/ssl-config-audit"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SslConfig />
              </>
            }
          />
          <Route
            exact
            path="/security-audit-settings"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <SecurityAuditSettings />
              </>
            }
          />
          <Route
            exact
            path="/vulnerabiity-audit"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <VulnerabilityAudit />
              </>
            }
          />
          <Route
            exact
            path="/vulnerabiity-detail/:id/:issueType"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <VulnerabilityDetail />
              </>
            }
          />
          <Route
            exact
            path="/content-structure-summary"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <ContentStructureSummary />
              </>
            }
          />
          <Route
            exact
            path="/content-structure-summary-detail/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <ContentStructureDetail />
              </>
            }
          />
          <Route
            exact
            path="/network-health-summary"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <NetworkHealthSummary />
              </>
            }
          />
          <Route
            exact
            path="/network-health-summary-detail/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <NetworkHealthSummaryDetail />
              </>
            }
          />

          <Route
            exact
            path="/visual-validation"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <VisualValidation />
              </>
            }
          />
          <Route
            exact
            path="/razorpay-plan/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <RazorpayPlan />
              </>
            }
          />
          <Route
            exact
            path="/pricing-page"
            element={
              <>

                <Pricingpage />
              </>
            }
          />
          <Route
            exact
            path="/ai-readiness"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AiReadiness />
              </>
            }
          />
          <Route
            exact
            path="/ai-readiness-detail/:id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AiReadinessDetail />
              </>
            }
          />
          <Route
            exact
            path="/ai-citation-reportsss"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AiPerformanceTracking />
              </>
            }
          />
          <Route
            exact
            path="/ai-citation-brandmention"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <BrandmentioncitationReport />
              </>
            }
          />
          <Route
            exact
            path="/ai-citation-report"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AicitationReport />
              </>
            }
          />
          <Route
            exact
            path="/content-detail/ai-analysis-summary/:id/:jobid"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Aiauditsummary />
              </>
            }
          />

          <Route
            exact
            path="/content-research"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Topicresearchdata />

              </>
            }
          />

          <Route
            exact
            path="/content-research-detail/:id/:campaign_id"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <Topicresearchdetail />
              </>
            }
          />

          <Route
            exact
            path="/link-building"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <LinkBuilding />
              </>
            }
          />

          <Route
            exact
            path="/ai-content-optimizer"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <AiContentOptimizer />
              </>
            }
          />

          <Route
            exact
            path="/ai-outreach-assistant"
            element={
              <>
                <LoginMiddleWare />
                <Userlogincontext />
                <Home />
                <Sidebar />
                <OutreachAssistant />
              </>
            }
          />

        </Routes>
      </Router>
    </>
  );
};

export default App;